module.exports = __webpack_public_path__ + "static/media/fondo1.c62f8744.jpg";